import { v4 as uuidv4 } from 'uuid';

export function FormInputTextarea(props = {}, childrenComponents = []) {
	return {
		componentName: 'FormInputTextarea',
		componentId: uuidv4(),
		props: Object.assign(
			{
				pointer: '',
				label: '',
			},
			props,
		),
		childrenComponents,
	};
}
